import { api } from "./apiClient";

export const Project = api.entities.Project;
export const Document = api.entities.Document;
export const ProjectMember = api.entities.ProjectMember;
export const Note = api.entities.Note;
export const AnalyticsEvent = api.entities.AnalyticsEvent;

// auth
export const User = api.auth;
